/** All possible tracking events for the user interaction with the Sidebar */
export let SidebarEvents = /*#__PURE__*/function (SidebarEvents) {
  SidebarEvents["expand"] = "expand sidebar";
  SidebarEvents["collapse"] = "collapse sidebar";
  SidebarEvents["openTab"] = "open sidebar tab";
  /** Triggers the event when user clicks on the Sphere logo to "go home" */
  SidebarEvents["goHome"] = "go home";
  /** Triggers the event when user navigates to HB Dashboard (after the feedback modal appeared) */
  SidebarEvents["navigateToHBDashboard"] = "navigate to holobuilder dashboard";
  /** Triggers when user clicks on the switch to navigate to the HB Dashboard */
  SidebarEvents["toggleSDBAccess"] = "toggle SXG dashboard access";
  return SidebarEvents;
}({});

/** All possible tracking events for the user interaction with the Side Panel */
export let SidePanelEvents = /*#__PURE__*/function (SidePanelEvents) {
  /** Trigger the event when the user opens a markup side panel */
  SidePanelEvents["openSidePanelMarkups"] = "open side panel markups";
  return SidePanelEvents;
}({});

/** All possible tracking events for the feedback modal */
export let FeedbackModalEvents = /*#__PURE__*/function (FeedbackModalEvents) {
  /** Triggers the event when user opens the feedback dialog */
  FeedbackModalEvents["openFeedbackDialog"] = "open feedback dialog";
  /**
   * Triggers the event when user clicks on the submit feedback button.
   * It should be used for any type of feedback and the feedback type should
   * be sent as a topic property
   */
  FeedbackModalEvents["submitFeedback"] = "send product feedback";
  /** Triggers the event when user clicks on the cancel feedback button.*/
  FeedbackModalEvents["cancelFeedback"] = "cancel feedback";
  /** Triggers the event when user clicks on the X button in feedback dialog */
  FeedbackModalEvents["closeFeedbackDialog"] = "close feedback dialog";
  return FeedbackModalEvents;
}({});

/** Possible tab properties for the "open sidebar tab" event */
export let SidebarTabs = /*#__PURE__*/function (SidebarTabs) {
  SidebarTabs["workspace"] = "workspace";
  return SidebarTabs;
}({});

/** Events to track in which file type the user wants to export the data */
export let ExportType = /*#__PURE__*/function (ExportType) {
  /** User clicked export button and started the export process */
  ExportType["exportTableStarted"] = "export table started";
  /** Export completed successfully (generic event for any format) */
  ExportType["exportTable"] = "export table";
  /** Export was cancelled by the user */
  ExportType["exportTableCancelled"] = "export table cancelled";
  /** Export failed due to error */
  ExportType["exportTableFailed"] = "export table failed";
  return ExportType;
}({});

/** Events to track which table the user wants to export its data as file */
export let TableType = /*#__PURE__*/function (TableType) {
  /** The list of groups table */
  TableType["groups"] = "groups";
  /** The list of projects in a group table */
  TableType["groupProjects"] = "group projects";
  /** The list of members in a group table */
  TableType["groupMembers"] = "group members";
  /** The list of members in a company table */
  TableType["companyMembers"] = "company members";
  /** The list of members in a project table */
  TableType["projectMembers"] = "project members";
  /** The list of active members counted in current subscription plan */
  TableType["activeMembers"] = "active members";
  /** The list of active projects table */
  TableType["activeProjects"] = "active projects";
  /** The list of archive projects table */
  TableType["archiveProjects"] = "archive projects";
  /** The list of background tasks table */
  TableType["backgroundTasks"] = "background tasks";
  /** The list of project markup tasks table */
  TableType["projectMarkups"] = "project markups";
  /** The list of projects of a group that a member belongs to */
  TableType["memberGroupProjects"] = "member group project";
  /** The list of teams table */
  TableType["teams"] = "teams";
  /** The list of members in a team table */
  TableType["teamMembers"] = "team members";
  /** The list of a markup's attachments in a table */
  TableType["markupAttachments"] = "markup attachments";
  /** The list of transactions in a table */
  TableType["creditTransactions"] = "credit transactions";
  /** The list of credit purchases in a table */
  TableType["creditPurchases"] = "credit purchases";
  /** The list of the projects map */
  TableType["mapProjects"] = "map projects";
  /** The list of the snapshots table */
  TableType["snapshots"] = "snapshots";
  /** The list of the analytics projects table */
  TableType["analyticsProjects"] = "analytics projects";
  return TableType;
}({});

/** Events to track when user interacts with the paginated table */
export let TableEvents = /*#__PURE__*/function (TableEvents) {
  /** Triggers the event when user clicks on the go to next or previous page */
  TableEvents["changePage"] = "change page";
  /** Triggers when user sorts items in any view (tables, tiles, lists) */
  TableEvents["sortItems"] = "sort items";
  /** Triggers when user changes column visibility */
  TableEvents["changeColumnVisibility"] = "change column visibility";
  /** Triggers when user changes column order */
  TableEvents["changeColumnOrder"] = "change column order";
  return TableEvents;
}({});

/** Events to track when user clicks on a particular button */
export let ButtonEvents = /*#__PURE__*/function (ButtonEvents) {
  /** Triggers the event when user clicks on the "load more" button */
  ButtonEvents["loadMore"] = "load more";
  /** Triggers the event when user clicks on one of the "clear cookies" buttons */
  ButtonEvents["clearCookies"] = "clear cookies";
  /** Triggers the event when user clicks on the "reset FUE flags" button */
  ButtonEvents["resetFueFlags"] = "reset FUE flags";
  /** Triggers the event when user clicks on the "send test Sentry error" button */
  ButtonEvents["sendTestSentryError"] = "send test Sentry error";
  /** Triggers the event when user toggles the allow localize translations */
  ButtonEvents["changeLocalizeOverride"] = "change localize override";
  /** Triggers the event when user toggles sending errors to Sentry */
  ButtonEvents["enableSentry"] = "enable Sentry";
  /** Triggers the event when user toggles sending product feedback to Teams */
  ButtonEvents["enableProductFeedback"] = "enable product feedback";
  return ButtonEvents;
}({});

/** Events to track when user perform a bulk action like changing role of multiple members or removing members etc. */
export let BulkActionEvents = /*#__PURE__*/function (BulkActionEvents) {
  /** Triggers when user clicks on the "change role" button for bulk action */
  BulkActionEvents["bulkChangeRole"] = "bulk change role";
  /** Triggers when user clicks on the "remove member" button for bulk action */
  BulkActionEvents["bulkRemoveMember"] = "bulk remove member";
  /** Triggers when user clicks on the "resend invitation" button for bulk action */
  BulkActionEvents["bulkResendInvitation"] = "bulk resend invitation";
  /** Triggers when user clicks on the "send email" button for bulk action */
  BulkActionEvents["bulkSendEmail"] = "bulk send email";
  /** Triggers when user clicks on the "change group project" button for bulk action */
  BulkActionEvents["bulkChangeGroup"] = "bulk change group";
  /** Triggers when user clicks on the "delete project" button for bulk action */
  BulkActionEvents["bulkDeleteProject"] = "bulk delete project";
  /** Triggers when user clicks on the "archive/unarchive project" button for bulk action */
  BulkActionEvents["bulkChangeProjectStatus"] = "bulk change project status";
  /** Triggers when user clicks on the "Pairwise registration" button for bulk actions in the point clouds table */
  BulkActionEvents["bulkPairwiseRegistration"] = "bulk pairwise registration";
  /** Triggers when user clicks on the "Delete Team" button for bulk actions */
  BulkActionEvents["bulkDeleteTeam"] = "bulk delete team";
  /** Triggers when user clicks on the "Remove" button to remove a member from the selected teams in bulk */
  BulkActionEvents["bulkRemoveMemberFromTeams"] = "bulk remove member from teams";
  /** Triggers when user clicks on the "Delete Markup" button for bulk actions */
  BulkActionEvents["bulkDeleteMarkup"] = "bulk delete markup";
  /** Triggers when user clicks on the "Delete" button for bulk actions in the markup's attachments table */
  BulkActionEvents["bulkDeleteMarkupAttachment"] = "bulk delete markup attachment";
  /** Triggers when user clicks on the "Delete" button for bulk actions in the snapshots table */
  BulkActionEvents["bulkDeleteSnapshots"] = "bulk delete snapshots";
  /** Triggers when user clicks on the "Remove members" button for bulk actions in the member group projects table */
  BulkActionEvents["bulkRemoveMemberFromProject"] = "bulk remove member from project";
  /** Triggers when user clicks on the "Change access level" button for bulk actions in the snapshots table */
  BulkActionEvents["bulkChangeSnapshotsAccessLevel"] = "bulk change snapshots access level";
  /** Triggers when user clicks on the "Change role" button for bulk actions in the member group projects table */
  BulkActionEvents["bulkChangeMemberProjectRole"] = "bulk change member project role";
  /** Triggers when user gives members access to SCENE in bulk, or takes it away from them */
  BulkActionEvents["bulkChangeSceneAccess"] = "bulk change scene access";
  /** Triggers when user gives members a Sphere XG seat in bulk */
  BulkActionEvents["bulkAssignXgSeat"] = "bulk assign xg seat";
  return BulkActionEvents;
}({});

/** Events to track when user does changes directly inside the table */
export let ProjectMemberEvents = /*#__PURE__*/function (ProjectMemberEvents) {
  /** Triggers when user clicks on the "change role" button */
  ProjectMemberEvents["changeRole"] = "change project member role";
  /** Triggers when user clicks on the "remove member" button */
  ProjectMemberEvents["removeMember"] = "remove member from project";
  /** Triggers when user clicks on the resend invitation button */
  ProjectMemberEvents["resendInvitation"] = "resend invitation";
  return ProjectMemberEvents;
}({});

/** Events to track when user does changes directly inside the group members table */
export let GroupMemberEvents = /*#__PURE__*/function (GroupMemberEvents) {
  /** Triggers the event when user clicks on the "Send Invite" button */
  GroupMemberEvents["inviteMembers"] = "invite members to group";
  /** Triggers when user change the role of a group member */
  GroupMemberEvents["changeRole"] = "change group member role";
  /** Triggers when user clicks on the "remove member" button */
  GroupMemberEvents["removeMember"] = "remove member from group";
  return GroupMemberEvents;
}({});
export let WorkspaceMemberEvents = /*#__PURE__*/function (WorkspaceMemberEvents) {
  /** Triggers when user clicks on the "change role" button */
  WorkspaceMemberEvents["changeRole"] = "change workspace member role";
  /** Triggers when user confirms to remove a member */
  WorkspaceMemberEvents["removeMember"] = "remove member from workspace";
  /** Triggers the event when user opens the profile (overview) page of a member */
  WorkspaceMemberEvents["openMemberProfilePage"] = "open profile page";
  /**
   * Triggers when the user picks a workspace role that needs a Sphere XG seat for a member without
   * one, which asks them to assign the seat first
   */
  WorkspaceMemberEvents["openXgSeatRequiredForRole"] = "open xg seat required for workspace role";
  /** Triggers when the user confirms to assign a Sphere XG seat and then change the role */
  WorkspaceMemberEvents["confirmXgSeatRequiredForRole"] = "confirm xg seat required for workspace role";
  /** Triggers when the user cancels assigning a Sphere XG seat, which leaves the role unchanged */
  WorkspaceMemberEvents["cancelXgSeatRequiredForRole"] = "cancel xg seat required for workspace role";
  return WorkspaceMemberEvents;
}({});

/** Events to track when user does changes directly inside the team members table */
export let TeamMemberEvents = /*#__PURE__*/function (TeamMemberEvents) {
  /** Triggers when user confirms to remove a member from team */
  TeamMemberEvents["removeMemberFromTeam"] = "remove member from team";
  return TeamMemberEvents;
}({});

// TODO: Change the name to account settings: https://faro01.atlassian.net/browse/ST-2831
/** Events to track on the user profile page */
export let UserProfile = /*#__PURE__*/function (UserProfile) {
  /** Triggers the event when user modifies permission of other user */
  UserProfile["updatePermissions"] = "update permissions";
  /** Triggers the event when user modifies profile info like name or email */
  UserProfile["updateProfile"] = "update profile";
  /** Triggers the event when user expands a group to see the projects contains in the profile page */
  UserProfile["expandGroupProjects"] = "expand group projects";
  /** Triggers the event when user filters a group's projects by direct or team access in the profile page */
  UserProfile["filterGroupProjects"] = "filter group projects";
  /** Triggers when user request deleting their account in the profile page */
  UserProfile["deleteAccount"] = "delete account";
  /** Triggers when user opens the cookie manager page */
  UserProfile["manageCookies"] = "manage cookies";
  /** Triggers the event when user changes the unit */
  UserProfile["changeUnit"] = "change unit";
  /** Triggers when user close the account settings page */
  UserProfile["closeAccount"] = "close user";
  /** Triggers the event when user changes the language */
  UserProfile["changeLanguage"] = "change language";
  /** Triggers when the user clicks on the button to connect an integration at user level */
  UserProfile["connectIntegration"] = "connect user integration";
  /** Triggers when the user clicks on the button to connect an integration at user level */
  UserProfile["disconnectIntegration"] = "disconnect user integration";
  return UserProfile;
}({});
export let SearchbarEvents = /*#__PURE__*/function (SearchbarEvents) {
  /** Trigger the event when search a workspace member */
  SearchbarEvents["searchForWorkspaceMember"] = "search for workspace members";
  /** Trigger the event when search a project */
  SearchbarEvents["searchForProject"] = "search for project";
  /** Trigger the event when search a team */
  SearchbarEvents["searchForTeam"] = "search for team";
  /** Trigger the event when search a team member */
  SearchbarEvents["searchForTeamMember"] = "search for team member";
  /** Triggered when the user searches for a group */
  SearchbarEvents["searchForGroup"] = "search for group";
  /** Triggered when the user searches for a workspace */
  SearchbarEvents["searchForWorkspace"] = "search for workspace";
  /** Triggered when the user searches for a snapshot */
  SearchbarEvents["searchForSnapshot"] = "search for snapshot";
  /** Triggered when the user searches for a member in the project Team tab */
  SearchbarEvents["searchForProjectMember"] = "search for project member";
  /** Triggered when the user searches for a member in the group Members tab */
  SearchbarEvents["searchForGroupMember"] = "search for group member";
  /** Triggered when the user searches for a project in the group project tabs */
  SearchbarEvents["searchForGroupProject"] = "search for group project";
  return SearchbarEvents;
}({});

/** All possible tracking events for the user interaction with the user menu */
export let UserMenuEvents = /*#__PURE__*/function (UserMenuEvents) {
  /** Triggers the event when user opens the user menu */
  UserMenuEvents["openUserMenu"] = "open user menu";
  /** Triggers the event when user clicks on the "account & security" button */
  UserMenuEvents["openAccountSettings"] = "open account settings page";
  /** Triggers the event when user clicks on the "Legal documents" button */
  UserMenuEvents["openLegalDocuments"] = "open legal documents";
  /** Triggers the event when user clicks on the "terms" button */
  UserMenuEvents["openTermsDetails"] = "open terms details";
  /** Triggers the event when user clicks on the "privacy" button */
  UserMenuEvents["openPrivacyDetails"] = "open privacy details";
  /** Triggers the event when user clicks on the "imprint" button */
  UserMenuEvents["openImprintDetails"] = "open imprint details";
  /** Triggers the event when user clicks on the "log out" button */
  UserMenuEvents["logOut"] = "log out";
  /** Triggers the event when user clicks on the "Log in" button */
  UserMenuEvents["logIn"] = "log in";
  /** Triggers the event when user opens the details page from a group */
  UserMenuEvents["openGroupDetails"] = "open group details";
  return UserMenuEvents;
}({});

/** All possible tracking events for the user interaction with the breadcrumb */
export let BreadcrumbEvents = /*#__PURE__*/function (BreadcrumbEvents) {
  BreadcrumbEvents["navigateWithBreadcrumb"] = "navigate with breadcrumb";
  return BreadcrumbEvents;
}({});

/** All possible tracking events for the user interaction with projects */
export let ProjectEvents = /*#__PURE__*/function (ProjectEvents) {
  /** Triggers when project feature setting is updated */
  ProjectEvents["adjustFeatureSettings"] = "adjust feature settings";
  /** Triggers when project settings are updated */
  ProjectEvents["updateProjectSettings"] = "update project settings";
  /** Triggers when user confirm the delete project dialog to delete a project*/
  ProjectEvents["deleteProject"] = "delete project";
  /** Triggers the event when user clicks on the "create new project" button */
  ProjectEvents["startCreateNewProject"] = "start create new project";
  /** Triggers the event when user finishes the creation of a new project */
  ProjectEvents["createNewProject"] = "create new project";
  /** Triggers the event when user opens the projects page */
  ProjectEvents["openProjectsPage"] = "open projects page";
  /** Triggers the event when user clicks on the "open project" button */
  ProjectEvents["openProject"] = "open project";
  /** Triggers the event when user open the project details (project overview page) */
  ProjectEvents["openProjectDetails"] = "open project details";
  /** Triggers the event when user clicks on the "share project" button */
  ProjectEvents["openShareProject"] = "open share project";
  /** Triggers the event when user clicks on the "archive project" button */
  ProjectEvents["archiveProject"] = "archive project";
  /** Triggers the event when user clicks on the "unarchive project" button */
  ProjectEvents["unarchiveProject"] = "unarchive project";
  /** Triggers when user opens an archived project in Sphere Vault to download it (beta) */
  ProjectEvents["openProjectInSphereVault"] = "open project in sphere vault";
  /** Triggers the event when user clicks on the "Send Invite" button */
  ProjectEvents["inviteMember"] = "invite member to project";
  /** The user clicks on copy link when sharing a project */
  ProjectEvents["copyShareProjectLink"] = "copy share project link";
  /** Triggers when the user confirms on enabling an integration on project level */
  ProjectEvents["connectIntegration"] = "connect project integration";
  /** Triggers when the user confirms disabling an integration on project level */
  ProjectEvents["disconnectIntegration"] = "disconnect project integration";
  /** Triggers when the first CoreAPI project token is fetched, to collect some technical metrics. */
  ProjectEvents["fetchProjectToken"] = "fetch project token";
  /** Triggers the event when user opens the project location editor */
  ProjectEvents["openProjectLocationEditor"] = "open project location editor";
  /** Triggers the event when user navigates the map to a project's location */
  ProjectEvents["goToProjectLocation"] = "go to project location";
  /** Triggers the event when user confirms the changes in the project location editor */
  ProjectEvents["updateProjectLocation"] = "update project location";
  /** Triggers the event when user clicks on the map of the project location editor to set a location */
  ProjectEvents["setProjectLocationOnMap"] = "set project location on map";
  /** Triggers the event when user toggles the project members list accordion */
  ProjectEvents["toggleProjectMembers"] = "toggle project members";
  return ProjectEvents;
}({});

/** All possible tracking events for the user interaction with snapshots */
export let SnapshotEvents = /*#__PURE__*/function (SnapshotEvents) {
  /** Triggers the event when user clicks on the "open snapshot" button */
  SnapshotEvents["openSnapshot"] = "open snapshot";
  /** Triggers when snapshots are loaded */
  SnapshotEvents["loadedSnapshots"] = "loaded snapshots";
  /** Triggers when user clicks on the "delete snapshot" button */
  SnapshotEvents["deleteSnapshot"] = "delete snapshot";
  /** Triggers the event when user clicks on the "copy snapshot link" button */
  SnapshotEvents["copySnapshotLink"] = "copy snapshot link";
  /** Triggers the event when user tries to edit the snapshot access level */
  SnapshotEvents["editSnapshot"] = "edit snapshot";
  /** Triggers the event when user clicks on the "share snapshot" button */
  SnapshotEvents["openShareSnapshot"] = "open share snapshot";
  /** Triggers the event when user clicks on the "remove member" menu item */
  SnapshotEvents["removeMember"] = "remove member from snapshot";
  /** Triggers the event when user toggles the snapshot members list accordion */
  SnapshotEvents["toggleSnapshotMembers"] = "toggle snapshot members";
  /** Triggers the event when user clicks on the "Invite" button */
  SnapshotEvents["inviteMember"] = "invite member to snapshot";
  /** Triggers the event when user clicks on the "Create snapshot" button */
  SnapshotEvents["createSnapshot"] = "create snapshot";
  return SnapshotEvents;
}({});

/** All possible events when using tabs, defines all the pages that can be opened  */
export let OpenTabEvents = /*#__PURE__*/function (OpenTabEvents) {
  /** Opens any tab inside the project details page */
  OpenTabEvents["openProjectTab"] = "open project tab";
  /** Opens any tab inside the group details page */
  OpenTabEvents["openGroupTab"] = "open group tab";
  /** Opens any tab inside the projects page */
  OpenTabEvents["openProjectsTab"] = "open projects tab";
  /** Opens any tab inside the analytics page */
  OpenTabEvents["openAnalyticsTab"] = "open analytics tab";
  /** Opens any tab inside the page for member profile page */
  OpenTabEvents["openMemberAccountTab"] = "open member account tab";
  /** Opens any tab inside the page for workspace settings */
  OpenTabEvents["openWorkspaceSettingsTab"] = "open workspace settings tab";
  /** Opens any tab inside the page for workspace users */
  OpenTabEvents["openWorkspaceUsersTab"] = "open workspace users tab";
  /** Opens any tab inside the page for a team */
  OpenTabEvents["openTeamTab"] = "open team tab";
  /** Opens any tab inside the page for account settings */
  OpenTabEvents["openAccountSettingsTab"] = "open account settings tab";
  return OpenTabEvents;
}({});

/** All possible events for user interaction with the analytics page */
export let AnalyticsEvents = /*#__PURE__*/function (AnalyticsEvents) {
  /** Triggers when the user applies a new date range in in-house analytics. */
  AnalyticsEvents["changeDateRange"] = "change analytics date range";
  return AnalyticsEvents;
}({});

/** All possible tracking events for when the user changes the project details */
export let ChangeProjectDetailsEvents = /*#__PURE__*/function (ChangeProjectDetailsEvents) {
  /** Triggers the event when user tries to change the project description */
  ChangeProjectDetailsEvents["changeProjectDescription"] = "change project description";
  /** Triggers the event when user tries to change the project address */
  ChangeProjectDetailsEvents["changeProjectAddress"] = "change project address";
  /** Triggers the event when user tries to change the project client */
  ChangeProjectDetailsEvents["changeProjectClient"] = "change project client";
  /** Triggers the event when user tries to change the project name */
  ChangeProjectDetailsEvents["changeProjectName"] = "change project name";
  /** Triggers the event when user tries to change the project access level */
  ChangeProjectDetailsEvents["changeProjectAccessLevel"] = "change project access level";
  /** Trigger the event when user tries to change the project thumbnail */
  ChangeProjectDetailsEvents["changeProjectThumbnail"] = "change project thumbnail";
  return ChangeProjectDetailsEvents;
}({});

/** All possible tracking events for when the user changes the group details */
export let ChangeGroupDetailsEvents = /*#__PURE__*/function (ChangeGroupDetailsEvents) {
  /** Triggers the event when user tries to change the group name */
  ChangeGroupDetailsEvents["changeGroupName"] = "change group name";
  /** Trigger the event when user tries to change the group thumbnail */
  ChangeGroupDetailsEvents["changeGroupThumbnail"] = "change group thumbnail";
  return ChangeGroupDetailsEvents;
}({});

/** All possible tracking events for the user interaction with a group as a whole */
export let GroupEvents = /*#__PURE__*/function (GroupEvents) {
  /** Triggers the event when user confirms deleting a group */
  GroupEvents["deleteGroup"] = "delete group";
  return GroupEvents;
}({});

/** All possible tracking events for the user interaction with the workspace */
export let WorkspaceEvents = /*#__PURE__*/function (WorkspaceEvents) {
  /** Triggers the event when user selects a workspace */
  WorkspaceEvents["selectWorkspace"] = "select workspace";
  /** Triggers the event when user clicks on the contact support button */
  WorkspaceEvents["contactSupport"] = "contact support";
  /** Triggers the event when user update the workspace settings */
  WorkspaceEvents["updateSettings"] = "update settings";
  /** Triggers whenever the page is loaded for the first time */
  WorkspaceEvents["pageLoaded"] = "page loaded";
  /** Triggers when the user clicks on the "Request a Quote" button from the "Trial is about to expire" banner */
  WorkspaceEvents["requestAQuote"] = "request a quote";
  /** Triggers the event when user clicks on the "Send Invite" button */
  WorkspaceEvents["inviteMembers"] = "invite members to workspace";
  /**
   * Triggers the event when user click on the "view transactions" on credits
   * or the toggle clicked to view the credit transactions
   */
  WorkspaceEvents["viewCreditsTransactions"] = "view transactions";
  /** Triggers the event when user click on the "Add credits" button */
  WorkspaceEvents["openAddCreditsPage"] = "open add credits page";
  /** Triggers the event when user click on the "View all" button or the toggle clicked to view the credit purchases */
  WorkspaceEvents["viewCreditsPurchaseHistory"] = "view credit purchases";
  /** Triggers the event when user click on the "Get quote" button from 'Add credits' dialog */
  WorkspaceEvents["requestQuote"] = "request quote";
  /** Triggers the event when user initiate a purchase of a credit package by pressing on "Purchase tokens" button */
  WorkspaceEvents["initiatePurchaseCredits"] = "initiate purchase credits";
  /** Triggers the event when user gets redirected to purchase success page to track payment completion */
  WorkspaceEvents["purchaseCreditsSuccess"] = "purchase credits success";
  /** Triggers when the user clicks on the "here" link from the "Exceeded subscription limits" banner */
  WorkspaceEvents["viewSubscriptionPage"] = "view subscription page";
  /** Triggered when the user clicks on the "Download code" button in "Export" section of the workspace settings */
  WorkspaceEvents["downloadCode"] = "download code";
  /** Triggered after the operation to download the code finishes */
  WorkspaceEvents["finishDownloadCode"] = "finish download code";
  /** Triggered when the user clicks on the button to download the data exporter app */
  WorkspaceEvents["downloadExporterApp"] = "download exporter app";
  /** Triggered when the user clicks on the button to view active members */
  WorkspaceEvents["viewActiveMembers"] = "view active members";
  /** Triggered when the user clicks on the button to view the assigned Scene license seats */
  WorkspaceEvents["viewSceneSeats"] = "view scene seats";
  /** Triggered when the user assigns Scene license seats to members */
  WorkspaceEvents["assignSceneSeats"] = "assign scene seats";
  /** Triggered when the user frees the Scene license seat of a member */
  WorkspaceEvents["unassignSceneSeat"] = "unassign scene seat";
  /** Triggered when the user assigns a Sphere XG seat to a member */
  WorkspaceEvents["assignXgSeat"] = "assign xg seat";
  return WorkspaceEvents;
}({});

/** All possible tracking events for user interaction with viewing data in different ways */
export let DataViewEvents = /*#__PURE__*/function (DataViewEvents) {
  /** Triggers the event when user changes the data view mode */
  DataViewEvents["changeViewMode"] = "change view mode";
  return DataViewEvents;
}({});
export let ErrorEvents = /*#__PURE__*/function (ErrorEvents) {
  /** Triggered when a user opens a page it should not have access (e.g. by opening a deep link) */
  ErrorEvents["openForbiddenPage"] = "open forbidden page";
  /** Triggered when a user opens a forbidden page and then logs in with a different user */
  ErrorEvents["openForbiddenPageDifferentUser"] = "open forbidden page different user";
  return ErrorEvents;
}({});

/** All possible events for user interaction with the project analytics tab */
export let ProjectActivityEvents = /*#__PURE__*/function (ProjectActivityEvents) {
  ProjectActivityEvents["openVideoModeTrajectory"] = "open videomode trajectory";
  return ProjectActivityEvents;
}({});

/** All possible events for user interaction with the in-house workspace analytics page */
export let InHouseAnalyticsEvents = /*#__PURE__*/function (InHouseAnalyticsEvents) {
  /** Triggers the event when a user selects a KPI metric to display in the chart */
  InHouseAnalyticsEvents["selectMetric"] = "select analytics metric";
  return InHouseAnalyticsEvents;
}({});

/** All possible events for user interaction with the project annotations tab */
export let AnnotationEvents = /*#__PURE__*/function (AnnotationEvents) {
  /** Triggers the event when user clicks on the "share annotation" button */
  AnnotationEvents["shareAnnotation"] = "share annotation";
  /** Triggers the event when user clicks on the copy button in share annotation dialog */
  AnnotationEvents["copyShareAnnotationLink"] = "copy share annotation link";
  /** Triggers the event when user adds a new attachment */
  AnnotationEvents["addNewAttachment"] = "add new attachment";
  /** Triggers the event when the user update any field */
  AnnotationEvents["editAnnotation"] = "edit annotation";
  /** Triggers the event when user clicks on an attachment item to preview it */
  AnnotationEvents["previewAttachment"] = "preview attachment";
  /** Triggers the event when user clicks on the download button */
  AnnotationEvents["downloadAttachment"] = "download attachment";
  /** Triggers the event when user clicks on the delete button */
  AnnotationEvents["deleteAttachment"] = "delete attachment";
  /** Triggers the event when user clicks on the delete annotation button */
  AnnotationEvents["deleteAnnotation"] = "delete annotation";
  /** Triggers the event when user clicks on the "open in new tab" button */
  AnnotationEvents["openAnnotationInNewTab"] = "open annotation in new tab";
  /** Triggers the event when user clicks on the "view details" button */
  AnnotationEvents["viewAnnotationDetails"] = "view annotation details";
  /** Triggers the event once the annotations tab is loaded, with the view and filters it was opened with */
  AnnotationEvents["loadedAnnotations"] = "loaded annotations";
  return AnnotationEvents;
}({});

/** All possible events for user interaction with the side panel of an annotation */
export let AnnotationSidePanelEvents = /*#__PURE__*/function (AnnotationSidePanelEvents) {
  /** Triggers the event when user steps to the previous or next annotation with the arrows of the side panel */
  AnnotationSidePanelEvents["stepToAnnotation"] = "step to annotation in side panel";
  /** Triggers the event when user opens the viewer from a level of the annotation location, e.g. its scan */
  AnnotationSidePanelEvents["openLocationInViewer"] = "open annotation location in viewer";
  /** Triggers the event when user expands or collapses a section of the annotation side panel, e.g. the activity */
  AnnotationSidePanelEvents["toggleSection"] = "toggle annotation side panel section";
  /** Triggers the event when user copies a measurement value or a coordinate of the annotation */
  AnnotationSidePanelEvents["copyValue"] = "copy annotation value";
  /** Triggers the event the first time user moves the camera of the annotation preview, by annotation */
  AnnotationSidePanelEvents["navigatePreview"] = "navigate annotation preview";
  /** Triggers the event when user resizes the annotation side panel, with its final width */
  AnnotationSidePanelEvents["resizeSidePanel"] = "resize annotation side panel";
  return AnnotationSidePanelEvents;
}({});

/** All possible events for user interaction with the annotations summary of the project overview */
export let AnnotationsSummaryEvents = /*#__PURE__*/function (AnnotationsSummaryEvents) {
  /** Triggers the event when user switches between the annotations assigned to them and all annotations */
  AnnotationsSummaryEvents["changeScope"] = "change annotations summary scope";
  /** Triggers the event when user clicks on a part of the summary to open the filtered annotations table */
  AnnotationsSummaryEvents["openAnnotations"] = "open annotations from summary";
  return AnnotationsSummaryEvents;
}({});

/** All possible events for user interaction with the calendar of the project annotations tab */
export let AnnotationsCalendarEvents = /*#__PURE__*/function (AnnotationsCalendarEvents) {
  /** Triggers the event when user moves the calendar to the previous or next week or month, or to today */
  AnnotationsCalendarEvents["navigate"] = "navigate annotations calendar";
  /** Triggers the event when user opens or closes the side panel of the calendar from its title, to pick a date */
  AnnotationsCalendarEvents["toggleDatePanel"] = "toggle annotations calendar date panel";
  /** Triggers the event when user changes a preference of the calendar, e.g. showing the weekends */
  AnnotationsCalendarEvents["changePreference"] = "change annotations calendar preference";
  return AnnotationsCalendarEvents;
}({});

/** All possible events for user interaction with the toolbar of the project annotations tab */
export let AnnotationsToolbarEvents = /*#__PURE__*/function (AnnotationsToolbarEvents) {
  /** Triggers the event when user shows or hides the filters of the annotations */
  AnnotationsToolbarEvents["toggleFilters"] = "toggle annotations filters";
  return AnnotationsToolbarEvents;
}({});

/** All possible events for user interaction with the board of the project annotations tab */
export let AnnotationsBoardEvents = /*#__PURE__*/function (AnnotationsBoardEvents) {
  /** Triggers the event when user drops an annotation in the column of another status */
  AnnotationsBoardEvents["moveAnnotation"] = "move annotation on board";
  return AnnotationsBoardEvents;
}({});

/** All possible events for tutorial page interactions */
export let TutorialEvents = /*#__PURE__*/function (TutorialEvents) {
  /** Triggers when user clicks on next button to view the next page */
  TutorialEvents["selectNextPage"] = "next tutorial page";
  /** Triggers when user clicks on back button to view the previous page */
  TutorialEvents["selectPreviousPage"] = "previous tutorial page";
  /** Triggers when user clicks on page indicator icons to jump to a certain page */
  TutorialEvents["jumpToPage"] = "jump to tutorial page";
  /** Triggers when user clicks on X button to skip (close) all the tutorial pages */
  TutorialEvents["skipTutorial"] = "skip tutorial";
  /** Triggers when user clicks on DONE button after viewing all the tutorial pages */
  TutorialEvents["finishTutorial"] = "finish tutorial";
  /** Triggers when user clicks on an external link within the tutorial */
  TutorialEvents["externalLinkClicked"] = "external link clicked";
  return TutorialEvents;
}({});

/** All possible events for progress overview menu */
export let ProgressOverviewEvents = /*#__PURE__*/function (ProgressOverviewEvents) {
  /** Triggers when user clicks on progress overview button to view progress */
  ProgressOverviewEvents["openProgressOverview"] = "open progress overview";
  return ProgressOverviewEvents;
}({});

/** All possible tracking events for the user interaction with user groups(teams) */
export let TeamEvents = /*#__PURE__*/function (TeamEvents) {
  /** Triggers the event when user clicks on the "create new team" button */
  TeamEvents["startCreateNewTeam"] = "start create new team";
  /** Triggers the event when user finishes the creation of a new team */
  TeamEvents["createNewTeam"] = "create new team";
  /** Triggers the event when user open the team details */
  TeamEvents["openTeam"] = "open team";
  /** Triggers the event when user tries to change any team details */
  TeamEvents["changeTeamDetails"] = "change team details";
  /** Triggers the event when user tries to delete the team */
  TeamEvents["deleteTeam"] = "delete team";
  /** Triggers the event when user clicks on the "Send Invite" button */
  TeamEvents["inviteMember"] = "invite member to team";
  return TeamEvents;
}({});

/** All possible tracking events for the user interaction with the top app bar */
export let AppBarEvents = /*#__PURE__*/function (AppBarEvents) {
  /** User opens the help dropdown menu */
  AppBarEvents["openHelpMenu"] = "open help menu";
  /** User closes the help dropdown menu */
  AppBarEvents["closeHelpMenu"] = "close help menu";
  /** User opens any help menu item, e.g. help videos */
  AppBarEvents["openHelpMenuItem"] = "open help menu item";
  /** User opens the Intercom chat successfully. */
  AppBarEvents["openChatSuccess"] = "open chat success";
  /** User fails to open the Intercom chat due to the Intercom chat not being initialized. */
  AppBarEvents["openChatNotInitialized"] = "open chat not initialized";
  /** User fails to open the Intercom chat due to being not logged in. */
  AppBarEvents["openChatNotLoggedIn"] = "open chat not logged in";
  /** User fails to open the Intercom chat due to missing the Intercom cookie. */
  AppBarEvents["openChatMissingCookie"] = "open chat missing cookie";
  return AppBarEvents;
}({});
export let ExternalLinkEvents = /*#__PURE__*/function (ExternalLinkEvents) {
  /** Triggers when user opens an external link */
  ExternalLinkEvents["openExternalLink"] = "open external link";
  return ExternalLinkEvents;
}({});
export let SubscriptionExpiredEvents = /*#__PURE__*/function (SubscriptionExpiredEvents) {
  /** Triggers when user's subscription has expired */
  SubscriptionExpiredEvents["subscriptionExpired"] = "subscription expired";
  /** Triggers when user requests a retention offer */
  SubscriptionExpiredEvents["requestRetentionOffer"] = "request retention offer";
  return SubscriptionExpiredEvents;
}({});

/** All possible tracking events for the user interaction with the world map */
export let WorldMapEvents = /*#__PURE__*/function (WorldMapEvents) {
  /** Triggers when user clicks on a cluster to expand it */
  WorldMapEvents["expandCluster"] = "expand map cluster";
  /** Triggers when user clicks on a marker to open the popup card of an entity */
  WorldMapEvents["openMarkerPopup"] = "open map marker popup";
  /** Triggers when user clicks on any button of the map controls */
  WorldMapEvents["useMapControl"] = "use map control";
  /** Triggers when the browser reports the outcome of the geolocation permission request */
  WorldMapEvents["locationPermission"] = "map location permission";
  /**
   * Triggers once per visit when the projects map page finishes loading, i.e. once
   * both the map view is ready and the projects fetch has settled. Carries the load
   * durations and project counts so page performance can be tracked in Amplitude.
   */
  WorldMapEvents["projectsMapLoaded"] = "projects map loaded";
  return WorldMapEvents;
}({});

/** All possible tracking events for the user interaction with the premium analytics feedback survey */
export let AnalyticsFeedbackEvents = /*#__PURE__*/function (AnalyticsFeedbackEvents) {
  /** Fires every time a survey step becomes visible */
  AnalyticsFeedbackEvents["viewStep"] = "viewed analytics survey step";
  /** Fires once when the user submits the completed survey */
  AnalyticsFeedbackEvents["completeSurvey"] = "completed analytics survey step";
  /** Fires when the user opts out of ever seeing the survey again */
  AnalyticsFeedbackEvents["dismissForever"] = "dismissed analytics survey forever";
  return AnalyticsFeedbackEvents;
}({});